export function formatCurrency(value: number): string {
  return `PKR ${new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 0,
  }).format(value)}`;
}

export function formatCompactCurrency(value: number): string {
  if (value >= 1_000_000) {return `PKR ${(value / 1_000_000).toFixed(1)}M`;}
  if (value >= 1_000) {return `PKR ${(value / 1_000).toFixed(1)}K`;}
  return `PKR ${value.toFixed(0)}`;
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat("en-US").format(value);
}

export function formatCompact(value: number): string {
  if (value >= 1_000_000) {return `${(value / 1_000_000).toFixed(1)}M`;}
  if (value >= 1_000) {return `${(value / 1_000).toFixed(1)}K`;}
  return value.toString();
}
